import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetPortfolioAgingTopDebtorsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "tier": {"code": "1_to_7", "label": "0 a 7 días"},
                "customers_count": 2,
                "tier_total": {"amount": 12000.00, "currency": "ARS"},
                "debtors": [
                    {
                        "position": 1,
                        "business_name": "Dunder Mifflin",
                        "fantasy_name": "Michael's Bakery",
                        "channel": "HORECA",
                        "amount": {"amount": 8000.00, "currency": "ARS"},
                        "aged_debts": [
                            {"type": "FC", "point_of_sale": "00012", "number": "00000123", "issue_date": "01-08-2026", "pending_amount": {"amount": 5000.00, "currency": "ARS"}},
                            {"type": "FC", "point_of_sale": "00012", "number": "00000124", "issue_date": "05-08-2026", "pending_amount": {"amount": 3000.00, "currency": "ARS"}},
                        ]
                    },
                    {
                        "position": 2,
                        "business_name": "Sabre Corporation",
                        "fantasy_name": "Sabre",
                        "channel": "Retail",
                        "amount": {"amount": 4000.00, "currency": "ARS"},
                        "aged_debts": [
                            {"type": "FC", "point_of_sale": "00012", "number": "00000456", "issue_date": "02-08-2026", "pending_amount": {"amount": 4000.00, "currency": "ARS"}},
                        ]
                    },
                ]
            },
            errors: []
        }
    }

    tier() {
        return this.content().tier;
    }

    customersCount() {
        return this.content().customers_count;
    }

    tierTotal() {
        return this.content().tier_total;
    }

    debtors() {
        return this.content().debtors.map(debtor => ({
            position: debtor.position,
            businessName: debtor.business_name,
            fantasyName: debtor.fantasy_name,
            channel: debtor.channel,
            amount: debtor.amount,
            agedDebts: debtor.aged_debts.map(agedDebt => ({
                type: agedDebt.type,
                pointOfSale: agedDebt.point_of_sale,
                number: agedDebt.number,
                issueDate: agedDebt.issue_date,
                pendingAmount: agedDebt.pending_amount,
            })),
        }));
    }
}
